import {connect} from "react-redux";
import {Error500} from "./view";

const Error500Container=connect()(Error500);
export default Error500Container;